export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Справочники: Служебные справочники",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
